// extracted by mini-css-extract-plugin
module.exports = {"button":"IconButton_button__29vBa","columns":"IconButton_columns__2VXVy","search":"IconButton_search__1R2T7","download":"IconButton_download__VHajX","add":"IconButton_add__yx8Hn"};